// 大屏设备列表分页：顺序读取，限制请求次数，不把截断结果当作全量。
export async function fetchDevicePages (fetchPage, { pageSize = 2000, maxPages = 5 } = {}) {
  const rows = []
  const seenIds = new Set()
  const seenPages = new Set()
  let total = null
  for (let current = 1; current <= maxPages; current += 1) {
    const data = await fetchPage({ current, size: pageSize })
    if (!data || !Array.isArray(data.dataList)) throw new Error('设备列表返回格式异常')
    if (data.total != null && data.total !== '') {
      const count = Number(data.total)
      if (!Number.isInteger(count) || count < 0) throw new Error('设备总量返回异常')
      total = count
    }
    const list = data.dataList
    if (!list.length) return { rows, total, truncated: total != null && rows.length !== total }
    const signature = JSON.stringify(list.map(row => row && row.id != null ? row.id : row))
    if (seenPages.has(signature)) return { rows, total, truncated: true }
    seenPages.add(signature)
    list.forEach(row => {
      if (!row || typeof row !== 'object') throw new Error('设备记录返回格式异常')
      if (row.id != null) {
        const id = String(row.id)
        if (seenIds.has(id)) return
        seenIds.add(id)
      }
      rows.push(row)
    })
    if (total != null && rows.length >= total) return { rows, total, truncated: rows.length !== total }
    // 无总量时继续到空页，兼容服务端缩小实际页大小的情况。
  }
  return { rows, total, truncated: true }
}
